module.exports = __webpack_public_path__ + "img/Bingmoo Mini Program.772d7081.jpg";